import * as Yup from 'yup';

const addReferrerTerminatedSchema = Yup.object().shape({
    ktpNumber: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Nomor KTP harus diisi')
        .length(16, 'Nomor KTP harus memiliki 16 digit.')
        .matches(/^[0-9]*$/, 'Nomor KTP harus memiliki 16 digit.')
});

export default addReferrerTerminatedSchema;